<template>
    <Head title="Create New Comparison" />
    <BreezeAuthenticatedLayout>
        <template #header>
            <h2 class="font-semibold text-xl text-gray-800 leading-tight">
                Update Comparison - {{ comparison.name }}
            </h2>
        </template>
        <BreadCrumbs :items="navItems"></BreadCrumbs>
        <div class="w-full my-6 overflow-hidden py-12 shadow">
            <div class="px-6 pt-4 pb-2">
                <form @submit.prevent="submit" class="w-full">
                    <div class="mb-6 md:mb-4">
                        <admin-app-label>Name</admin-app-label>
                        <input-basic
                            placeholder="Name"
                            v-model="form.name"
                            :error="errors['name']"
                        />
                        <input-error v-if="errors['name']">
                            {{ errors.name }}
                        </input-error>
                    </div>
                    <div class="mb-6 md:mb-4">
                        <admin-app-label>Description</admin-app-label>
                        <input-wysiwyg
                            v-model="form.description"
                        ></input-wysiwyg>
                        <input-error v-if="errors['description']">
                            {{ errors.description }}
                        </input-error>
                    </div>
                    <div class="mb-6 md:mb-4">
                        <admin-app-label>Products</admin-app-label>
                        <input-select
                            multiple
                            searchable
                            placeholder="Products"
                            labelKey="Product"
                            v-model="form.products"
                            :options="products"
                            :value="selected"
                            :get-option-label="getLabel"
                            :error="errors['products']"
                            label="name"
                            :reduce="product => product.id"
                        >
                        </input-select>
                    </div>
                    <seo-tags v-model="form.seo_tags" :errors="errors"></seo-tags>
                    <app-button type="submit" class="mt-8">Update</app-button>
                </form>
            </div>
        </div>
    </BreezeAuthenticatedLayout>
</template>
<script>
import { useForm } from '@inertiajs/inertia-vue3';
import BreadCrumbs from "@/Components/Admin/BreadCrumbs";
import AdminAppLabel from "@/Components/Admin/Forms/AdminAppLabel";
import AppButton from "@/Components/AppButton";
import InputBasic from "@/Components/Admin/Forms/Inputs/InputBasic";
import InputWysiwyg from "@/Components/Admin/Forms/Inputs/InputWysiwyg";
import Label from "@/Components/Label";
import BreezeAuthenticatedLayout from "@/Layouts/Admin/Authenticated";
import {Head} from "@inertiajs/inertia-vue3";
import InputError from "@/Components/Forms/Inputs/InputError";
import InputSelect from "@/Components/Admin/Forms/Inputs/InputSelect";
import SeoTags from "@/Components/Admin/Forms/SeoTags";

export default {
    components: {
        SeoTags,
        InputSelect,
        BreadCrumbs,
        AdminAppLabel,
        AppButton,
        InputBasic,
        InputWysiwyg,
        Label,
        BreezeAuthenticatedLayout,
        Head,
        InputError,
    },
    props: {
        name: String,
        description: String,
        products: Object,
        comparison: Object,
        errors: Object,
    },
    data() {
        return {
            navItems: [
                { title: 'Comparisons', path: '/admin/comparisons'},
            ],
            selected: [],
            form: this.$inertia.form({
                ...this.comparison,
                _method: "put",
                products: (this.comparison.products !== null && this.comparison.products.h1_tag !== null) ? this.comparison.products : "",
            }),
        }
    },
    mounted() {
        var valueToPush = { };
        valueToPush.title = '#'+ this.comparison.id;
        valueToPush.path = "/admin/comparisons/"+this.comparison.id+"/edit";

        this.navItems.push(valueToPush);

        var chosen_products = { };
        this.comparison.products.forEach(product =>
        {
            chosen_products = product.id;
            //chosen_products = this.getLabel(product);
            this.selected.push(chosen_products);
        });
    },
    methods: {
        submit()
        {
            this.form.post(`/admin/comparisons/${this.comparison.id}`);
        },
        getLabel: function(val)
        {
            if(typeof  val === 'object')
            {
                return val.name + ' | ' + val.identifier + ' | ' + this.capitaliseFirst(val.type)
            }
        },
        capitaliseFirst(str)
        {
            if (!str) return;
            return str.match("^[a-z]") ? str.charAt(0).toUpperCase() + str.substring(1) : str;
        }
    }
}
</script>
